(function () {
  'use strict';

  // ─── CONFIG ────────────────────────────────────────────────────────────────
  var CONFIG = {
    endpoint:    'https://bff-api.automizely.com/edd/v1/product-aedd',
    appKey:      'toolupstore',
    appPlatform: 'shopify',
    languageCode: 'en',
    labelSelector: '.as-edd-label',
    chunkSize:   5,
    gridSelectors: ['#product-grid', '.product-grid', '[id^="product-grid"]', 'main'],
    debounceMs:  150,
    debug:       false
  };

  function labelMarkup(formatted) {
    return '<p class="as-edd-text" style="font-size:13px;color:#1a1a1a;' +
           'margin:4px 0 0;font-weight:600;">🚚 Est Delivery ' + formatted + '</p>';
  }

  function log() {
    if (CONFIG.debug && window.console) {
      console.log.apply(console, ['[aftership-edd]'].concat([].slice.call(arguments)));
    }
  }

  function track(event, data) {
    data = data || {};
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(Object.assign({ event: 'aftership_edd_' + event }, data));
      }
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'aftership_edd_' + event, data);
      }
      document.dispatchEvent(new CustomEvent('aftership-edd:' + event, { detail: data }));
    } catch (e) {}
    log('track', event, data);
  }

  function formatDate(dateStr) {
    var date = new Date(dateStr + 'T00:00:00');
    if (isNaN(date.getTime())) return null;
    return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  function pendingLabels() {
    return Array.from(document.querySelectorAll(CONFIG.labelSelector))
      .filter(function (el) { return !el.dataset.eddState; });
  }

  function chunkArray(arr, size) {
    var chunks = [];
    for (var i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  }

  function processChunk(chunk) {
    var variants = chunk.map(function (el) {
      return {
        external_product_id: el.getAttribute('data-product-id'),
        external_variant_id: el.getAttribute('data-variant-id')
      };
    }).filter(function (v) { return v.external_product_id && v.external_variant_id; });

    if (!variants.length) return Promise.resolve();

    chunk.forEach(function (el) { el.dataset.eddState = 'pending'; });
    log('requesting chunk of', variants.length, 'variants');

    return fetch(CONFIG.endpoint, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({
        app_key:       CONFIG.appKey,
        app_platform:  CONFIG.appPlatform,
        is_editor:     false,
        variants:      variants,
        language_code: CONFIG.languageCode
      })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    })
    .then(function (resp) {
      var items = (resp && resp.data && resp.data.items) || [];
      var rendered = 0;

      items.forEach(function (item) {
        var dateStr = item.estimated_delivery_date_max || item.estimated_delivery_date;
        if (!dateStr) return;
        var formatted = formatDate(dateStr);
        if (!formatted) return;

        chunk
          .filter(function (el) {
            return el.getAttribute('data-variant-id') === String(item.external_variant_id);
          })
          .forEach(function (el) {
            el.innerHTML = labelMarkup(formatted);
            el.dataset.eddState = 'done';
            rendered++;
          });
      });

      chunk.forEach(function (el) {
        if (el.dataset.eddState === 'pending') el.dataset.eddState = 'done';
      });

      track('rendered', {
        requested:   variants.length,
        rendered:    rendered,
        render_rate: variants.length ? +(rendered / variants.length).toFixed(3) : 0
      });
      log('rendered', rendered, '/', variants.length);
    })
    .catch(function (err) {
      chunk.forEach(function (el) {
        if (el.dataset.eddState === 'pending') delete el.dataset.eddState;
      });
      track('error', { message: String(err && err.message || err), requested: variants.length });
      if (window.console) console.warn('[aftership-edd] chunk request failed:', err);
    });
  }

  function run() {
    var labels = pendingLabels();
    if (!labels.length) return;

    var chunks = chunkArray(labels, CONFIG.chunkSize);
    log('processing', labels.length, 'labels in', chunks.length, 'chunks');

    Promise.all(chunks.map(function (chunk) {
      return processChunk(chunk);
    }));
  }

  // ─── INIT ──────────────────────────────────────────────────────────────────
  run();

  var grid = null;
  for (var i = 0; i < CONFIG.gridSelectors.length && !grid; i++) {
    grid = document.querySelector(CONFIG.gridSelectors[i]);
  }
  var target = grid || document.body;
  log('observing', grid ? CONFIG.gridSelectors[i - 1] : '<body> (fallback)');

  var timer = null;
  var observer = new MutationObserver(function (mutations) {
    var addedNodes = mutations.some(function (m) { return m.addedNodes.length; });
    if (!addedNodes) return;
    clearTimeout(timer);
    timer = setTimeout(run, CONFIG.debounceMs);
  });
  observer.observe(target, { childList: true, subtree: true });
})();